<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-two-saturday">
<h1>Chapter Two<br/> (Saturday)</h1>
<p><em>Scott</em></p>
<p><em>That girl is gorgeous</em> Scott thought aloud as he was arranging his clothes into the wardrobe. His plan had worked–to find out where she was and then accidentally-on-purpose fall into her.</p>
<p>To be honest, he had no clue how he had found her, call it a sixth sense or something. He already had a picture of her imprinted into his mind. She must be around 5ft 4, emerald green eyes, short purple spiky hair, and not forgetting those amazing wings, dark brown edged in a greeny colour. They must be at least 10 feet wide.</p>
<p>“Who’s gorgeous? Or are you daydreaming again, Scottie?”</p>
<p>Jack Preston, Scott’s roommate, sauntered through the door, and leaned his short blonde frame against it, swaying to a silent tune.</p>
<p>“This new girl. She’s called Jamieson, you must’ve seen her already!”</p>
<p>“Um, you’re gonna have to be a bit more specific than that mate, there are a few new girls this term. What does she look like?” Jack fished.</p>
<p>“Well, she has short purple hair, green eyes and the most wonderful pair of wings. She is unforgettable!” he swooned.</p>
<p>“So, does she have a name?”</p>
<p>“I already told you, Jamieson.”</p>
<p>“Oh yeah? So she likes you too…or are you stalking her? How old is she?”</p>
<p>“I dunno, I’m working on it though, give me a chance, and I’m not the one who stalks people!” Scott turned around to emphasise his point but Jack had disappeared.</p>
<p>“I hate it when he does that!” Scott resumed his task, remembering back to when he first met his best friend.</p><br/>
<p><em>This time last year, Scott was the new guy. He stumbled through the doors much like he’d seen Jamie do this afternoon. Bewildered, and lonely, then Jack had bumped his shoulder and introduced himself, they’d been friends since that day, with the same classes, and then strangely the same dorm room too.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?b22fca42